var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.667 29.2a1.2 1.2 0 0 1-.15-2.39l.15-.01H2.8V10.55c0-1.268.977-2.308 2.22-2.409l.197-.008h4.249v-2.8a2.534 2.534 0 0 1 2.336-2.525L12 2.8h8a2.534 2.534 0 0 1 2.526 2.335l.007.198v2.8h4.25c1.268 0 2.308.977 2.409 2.22l.008.198V26.8h.133a1.2 1.2 0 0 1 .15 2.39l-.15.01H2.667zm6.799-18.667H5.217l-.012.005-.005.013V26.8h4.266v-4.4H7.333a1.2 1.2 0 0 1-.15-2.39l.15-.01h2.133v-4.267H7.333a1.2 1.2 0 0 1-.15-2.39l.15-.01h2.133v-2.8zM20 5.2h-8a.133.133 0 0 0-.123.081l-.01.052-.001 21.467H14.8v-1.467a1.2 1.2 0 0 1 2.39-.15l.01.15V26.8h2.933V5.333a.133.133 0 0 0-.081-.123L20 5.2zm6.783 5.333h-4.25v2.8h2.134a1.2 1.2 0 0 1 .15 2.391l-.15.01-2.134-.001V20h2.134a1.2 1.2 0 0 1 .15 2.39l-.15.01h-2.134v4.4H26.8V10.55l-.005-.012-.012-.005zM18 18.667a1.2 1.2 0 0 1 .15 2.39l-.15.01h-4a1.2 1.2 0 0 1-.15-2.391l.15-.01h4zm0-5.334a1.2 1.2 0 0 1 .15 2.391l-.15.01h-4a1.2 1.2 0 0 1-.15-2.391l.15-.01h4zM18 8a1.2 1.2 0 0 1 .15 2.39l-.15.01h-4a1.2 1.2 0 0 1-.15-2.39L14 8h4z",
    fill: "#727DF9",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsOffice);
export default __webpack_public_path__ + "static/media/icons-office.df31c1cb7da18347776a51d83e52025e.svg";
export { ForwardRef as ReactComponent };